import { makeStyles } from 'makeStyles';

export const useStyles = makeStyles()(() => ({
  avoidancePaper: {
    marginBottom: 30,
  },
  avoidanceTitleTypography: {
    marginBottom: 10,
  },
  avoidancePanelTypographyBold: {
    fontWeight: 600,
  },
  avoidanceIcon: {
    marginRight: 10,
  },
}));
